<template>
  <div class="content  import_new_wrap">
    <div style="display: flex">
      <div class="fl back-color-fff borderR6 left-tree-box first-table " :style="'height:' + tableLeftHeight + 'px;'">
        <el-input @keyup.enter.native="searchMainList()" size="mini" placeholder="输入关键字搜索" v-model="mainPage.ruleName"
          clearable style="width: 80%; margin-top:10px;">
        </el-input>
        <el-button icon="el-icon-plus" class="add-btn" @click="addData">新增分级规则</el-button>

        <el-table :data="tagList" ref="singleTable" highlight-current-row row-key="guid" :show-header="false"
          @row-click="searchDetailList">
          <el-table-column prop="ruleName">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ruleName" class="item" effect="light" :content="scope.row.ruleName"
                placement="left">
                <div style="padding-left: 6px;">{{ scope.row.ruleName }}</div>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="65" align="right">
            <template slot-scope="scope">
              <!-- v-if="shbtn[scope.$index]" -->
              <div class="btn">
                <i class="el-icon-edit-outline i-edit-sty" @click.stop="updateData(scope.row)"></i>
                <i class="el-icon-delete i-sty" @click.stop="getDeleteData('main', scope.row.guid)"></i>
              </div>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination :current-page="mainPage.pageIndex" :page-size="mainPage.pageSize" layout="prev, pager, next"
          small :pager-count="5" @current-change="mainCurrentChange" :total="mainPage.totalRows">
        </el-pagination>
      </div>

      <div class="right-content-box back-color-fff">
        <div style="display:flex;justify-content:space-between;">
          <div class="button-area">
            <el-button size="mini" type="danger" @click="getDeleteData('all', '')">批量删除</el-button>
          </div>
          <div class="button-area" style="padding-right:0">
            <el-input size="mini" placeholder="分级/级别搜索" v-model="detailPage.keyWork" clearable
              style="width: 140px; margin-right:10px ">
            </el-input>
            <el-button size="mini" type="primary" @click="searchDetailList(currentRow,true)">搜索</el-button>
            <el-button size="mini" type="danger"
              @click="detailPage.keyWork='';searchDetailList(currentRow,true)">清空</el-button>

          </div>
        </div>
        <div class="content-main-box" style="height:calc(100% - 110px)">
          <el-table v-loading="loading" stripe border row-key="guid" style="width:882px" tooltip-effect="light"
            height="100%" :data="tableData" @selection-change="handleSelectionChange">
            <!-- selection -->
            <el-table-column type="selection" width="40" header-align="center" align="center"
              fixed="left"></el-table-column>
            <!-- 序号 -->
            <el-table-column prop="orderNum" label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope"> {{  (detailPage.pageIndex - 1) * detailPage.pageSize + scope.$index + 1 }}</template>
            </el-table-column>

            <!-- 分级 -->
            <el-table-column prop="levelName" width="160" label="分级" header-align="center" align="left"
              show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.levelName||'-'}}</template>
            </el-table-column>
            <!-- 级别 -->
            <el-table-column prop="levelNote" width="160" label="级别" header-align="center" align="left"
              show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.levelNote||'-'}}</template>
            </el-table-column>
            <!-- 系数 -->
            <el-table-column prop="coefficient" width="80" label="系数" header-align="center" align="left"
              show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.coefficient != null ? formatMoney(scope.row.coefficient) : '-' }}</template>
            </el-table-column>
            <!-- 最小值 -->
            <el-table-column prop="minValue" width="80" label="最小值" header-align="center" align="left"
              show-overflow-tooltip>
              <template slot-scope="scope"> {{scope.row.minValue!=null? scope.row.minValue:'-'}}</template>
            </el-table-column>
            <!-- 最大值 -->
            <el-table-column prop="maxValue" width="80" label="最大值" header-align="center" align="left"
              show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.maxValue!=null? scope.row.maxValue:'-'}}</template>
            </el-table-column>
            <!-- 更新时间 -->
            <el-table-column prop="createTime" width="160"  label="更新时间" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column label="操作" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="getDeleteData('detail',scope.row.guid)"> 删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="pt pb back-color-fff" background @size-change="detailSizeChange"
          @current-change="detailCurrentChange" :current-page="detailPage.pageIndex" :page-size="detailPage.pageSize"
          layout="total, prev, pager, next, jumper" :total="detailPage.totalRows">
        </el-pagination>

      </div>
    </div>
    <!-- start of dialog-右侧医药词典添加分类-新增|编辑 -->
    <el-dialog :title="isAdd ? '新增分级规则' : '编辑分级规则'" :visible.sync="editDialog" width="900px">
      <el-form v-if="editDialog" ref="formData" label-width="80px" :model="formData" :rules="formRules">
        <div class="item-flex">
          <!-- 维度名称 -->
          <el-form-item label="维度名称" prop="ruleName">
            <el-input size="small" maxlength="30" v-model="formData.ruleName" placeholder="请输入" clearable
              @input="formData.ruleName = formData.ruleName.replace(/\s+/g, '')" />
          </el-form-item>
          <!-- 维度编码 -->
          <el-form-item label="维度编码" prop="ruleCode" style="margin-left:20px">
            <el-input size="small" maxlength="20" v-model="formData.ruleCode" placeholder="请输入" clearable
              @input="formData.ruleCode = formData.ruleCode.replace(/[^\d]/g, '')" />
          </el-form-item>
        </div>
        <div class="item-flex">
          <!-- 界面排序 -->
          <el-form-item label="界面排序" prop="orderNum">
            <el-input size="small" maxlength="30" v-model="formData.orderNum" placeholder="请输入" clearable
              @input="formData.orderNum = formData.orderNum.replace(/[^\d]/g, '')" />
          </el-form-item>
          <!-- 启用状态 -->
          <el-form-item label="启用状态" prop="bizState" style="margin-left:20px">
            <el-radio-group v-model="formData.bizState">
              <el-radio label="Y">启用</el-radio>
              <el-radio label="S">停用</el-radio>
            </el-radio-group>
          </el-form-item>

        </div>
        <div class="item-flex">
          <!-- 分级方式 -->
          <el-form-item label="分级方式" prop="levelType">
            <el-select style="width: 100%;" size="small" filterable v-model="formData.levelType"
              @change="formData.dicGuid='';formData.detailList=[];relGuidList=[]" placeholder="请选择">
              <el-option v-for="item in levelTypeList" :label="item.text" :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 平台字典 -->
          <el-form-item label="平台字典" prop="dicGuid" v-if="formData.levelType == 1" style="margin-left:20px">
            <el-select style="width: 100%;" size="small" @change="dicGuidChange" filterable v-model="formData.dicGuid"
              placeholder="请选择">
              <el-option v-for="item in dicGuidList" :label="item.dictTypeName" :value="item.guid" :key="item.guid">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div style="text-align:left;">
        <el-button style="margin-bottom:20px;" icon="el-icon-plus" type="primary" size="mini"
          @click="addDetailList">新增</el-button>
      </div>
      <div class="content-main-box level-box">
    
        <el-table v-if="formData.levelType == 1" style="width: 100%;" tooltip-effect="light" height="100%"
          :data="formData.detailList">
          <!-- 字典 -->
          <el-table-column prop="levelName" label="" header-align="center" align="left" show-overflow-tooltip>
            <template #header>
              分级<span style="color:red">*</span>
            </template>
            <template slot-scope="scope">
              <el-select style="width: 100%;" size="small" @change="relGuidChange(scope.row)" filterable
                v-model="scope.row.relGuid" placeholder="请选择">
                <el-option v-for="item in relGuidList" :label="item.text" :value="item.guid" :key="item.guid">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <!-- 分级规则描述 -->
          <el-table-column prop="levelNote" label="级别" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.levelNote"
                placeholder="请输入" clearable @input="scope.row.levelNote = scope.row.levelNote.replace(/\s+/g, '')" />
            </template>
          </el-table-column>
          <!-- 最小值 -->
          <el-table-column :renderHeader="minHeader" prop="minValue" width="120" label="最小值（含）" header-align="center"
            align="left" show-overflow-tooltip>

            <template slot-scope="scope">
              <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.minValue"
                placeholder="请输入" clearable @input="scope.row.minValue = scope.row.minValue.replace(/[^\d]/g, '')" />
            </template>
          </el-table-column>
          <!-- 最大值 -->
          <el-table-column :renderHeader="maxHeader" prop="maxValue" width="120" label="最大值（不含）" header-align="center"
            align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.maxValue"
                placeholder="请输入" clearable @input="scope.row.maxValue = scope.row.maxValue.replace(/[^\d]/g, '')" />
            </template>
          </el-table-column>
          <!-- 系数 -->
          <el-table-column prop="coefficient" width="100" label="系数" header-align="center" align="left"
            show-overflow-tooltip>
            <template #header>
              系数<span style="color:red">*</span>
            </template>
            <template slot-scope="scope">
              <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.coefficient"
                placeholder="请输入" clearable
                oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
                />
            </template>
          </el-table-column>
          <!-- 界面排序 -->
          <el-table-column prop="orderNum" label="序号" width="100" header-align="center" align="right">
            <template slot-scope="scope">
              <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.orderNum"
                placeholder="请输入" clearable @input="scope.row.orderNum = scope.row.orderNum.replace(/[^\d]/g, '')" />
            </template>
          </el-table-column>

          <el-table-column label="操作" header-align="center" align="center" width="80">
            <template slot-scope="scope">
              <a class="txt-color" @click="delDetailList(scope.$index)"> 删除</a>
            </template>
          </el-table-column>
        </el-table>
        <div class="table2" style="width: 100%; height:100%">
          <el-table v-if="formData.levelType == 2" style="width: 100%;" height="100%"
            :data="formData.detailList">
            <!-- 分级 -->
            <!-- 超级模版 -->
            <el-table-column prop="levelName" label="分级" header-align="center" align="left" show-overflow-tooltip>
              <template #header>
                分级<span style="color:red">*</span>
              </template>
              <template slot-scope="scope">
                {{ scope.row.levelName }}
              </template>
            </el-table-column>
            <!-- 分级规则描述 -->
            <el-table-column prop="levelNote" label="级别" header-align="center" align="left" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.levelNote ||'-'}}
                <!-- <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.levelNote"
                                  placeholder="请输入" clearable
                                  @input="scope.row.levelNote = scope.row.levelNote.replace(/\s+/g, '')" /> -->
              </template>
            </el-table-column>
            <!-- 系数 -->
            <el-table-column  prop="coefficient" width="100" label="系数" header-align="center" align="left"
              show-overflow-tooltip>
              <template #header>
                系数<span style="color:red">*</span>
              </template>
              <template slot-scope="scope">
                <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.coefficient"
                  placeholder="请输入" clearable
                  oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
                  />
              </template>
            </el-table-column>
            <!-- 界面排序 -->
            <el-table-column prop="orderNum" label="序号" width="100" header-align="center" align="right">

              <template slot-scope="scope">
                <el-input class="level-box-input" size="small" maxlength="30" v-model="scope.row.orderNum"
                  placeholder="请输入" clearable @input="scope.row.orderNum = scope.row.orderNum.replace(/[^\d]/g, '')" />
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="80">
              <template slot-scope="scope">
                <a class="txt-color" @click="delDetailList(scope.$index)"> 删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitDict()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-右侧医药词典添加分类-新增|编辑 -->

    <!-- 产品选择弹窗 开始 -->
    <el-dialog title="超级模版选择" v-if="goodsVisible" :visible.sync="goodsVisible" width="80%" center>
      <el-row :gutter="24" class="mb30">
        <el-col :span="6">
          <div style="line-height:26px">任务名称：</div>
          <el-input size="mini" v-model="superPage.taskContentName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6">
          <div style="line-height:26px">系统功能：</div>
          <el-input size="mini" v-model="superPage.menuName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6">
          <div style="line-height:26px">终端类型分类：</div>
          <el-select size="mini" multiple collapse-tags class="ipt-sty"
            v-model="superPage.terminalTypeClassificationJson" filterable clearable placeholder="请选择">
            <el-option v-for="item in getCodeListByKey('终端类型分类')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-button size="mini" type="info" @click="getSuperTemplateList(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearchSuper">清空</el-button>
        </el-col>
      </el-row>
      <div class="back-color-fff content-main-box" style="width: 100%;height:520px;overflow-y:scroll">
        <el-table :data="superTemplateList" style="width: 100%; border-bottom: 1px solid #EBEEF5 !important;" stripe
          border header-cell-class-name="table_header" row-key="guid" @selection-change="handleSuperSelectionChange"
          ref="dataTable" @row-click="btn">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (superPage.pageIndex - 1) * superPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务名称" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="终端类型分类" show-overflow-tooltip header-align="center"
            align="center">
            <template
              slot-scope="scope">{{scope.row.terminalTypeClassificationJson?codeTransformLable(JSON.parse(scope.row.terminalTypeClassificationJson),
              getCodeListByKey('终端类型分类')):'-' }}</template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="任务简述" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.staffTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="tenantTaskNote" label="任务说明" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">{{ scope.row.tenantTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="系统功能" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.menuName }}{{ scope.row.menuRemark ? '（' +
              scope.row.menuRemark +
              ')' : ''
              }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="业务员报价" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination class="pt pb back-color-fff" background @size-change="goodsSizeChange"
        @current-change="goodsCurrentChange" :current-page="superPage.pageIndex" :page-size="superPage.pageSize"
        layout="total, prev, pager, next, jumper" :total="superPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="goodsVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="sureChooseGoods">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>

  export default {
    data() {
      return {
        tableLeftHeight: window.innerHeight - 102,
        loading: false,
        visible:false,
        dicNameTitle:'',
       
        ruleName:'',//分级规则名称
        dictTypeGuid:'',//左侧分级规则的分类
        readList:[],//阅读情况的列表
        medicineDictGuid:'',//存储阅读
        guids:[],
        readTitle:'',
        tagList:[ ],//分类列表
        classList:[ ],//上级分级规则列表
        levelTypeList: this.getCodeListByKey('分级方式'),
        dicGuidList: JSON.parse(localStorage.codeList),
        relGuidList:[],
        className:'',//分级规则分类搜索
        isEdit:false,
        tenantGuid:null,
        formData:{
          guid: '',
          ruleName	: '', //规则名称
          ruleCode: '', // 规则编码
          orderNum: null, // 界面排序
          bizState: 'Y', // 启用状态
          levelType:'1',//分级方式
          dicGuid:'',//平台字典
          detailList:[]
        },
        currentRow:null,
        isAdd : false,
        formRules: {
          ruleName: [
            { required: true, message: '维度名称必填', trigger: 'blur' },
          ],
          ruleCode: [
            { required: true, message: '维度编码必填', trigger: 'blur' },
          ],
          levelType: [
            { required: true, message: '分级方式必填', trigger: 'blur' },
          ],
          bizState: [
            { required: true, message: '启用状态必填', trigger: 'blur' },
          ],
          dicGuid:[
          { required: true, message: '平台字典必填', trigger: 'blur' },
          ]
        },
        tableData:[],
        // 弹窗
        editTypeDialog:false,
        editDialog:false,
        fullscreenLoading:false,
        multipleSelection:[],
        superPage: {//超级模版请求参数
            isSuper: 'Y',
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            totalRows: 0,
            bizState:'Y',
            taskContentName: null, //任务名称
            menuName: '', //菜单名称
            terminalTypeClassificationJson:[]
        },
        mainPage:{
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          ruleName:''
        },
        detailPage:{
          pageIndex: 1,
          pageSize: 20,
          totalPage: 0,
          totalRows: 0,
          keyWork:'',
          guid:''
        },
        superTemplateList:[],
        multipleSuperSelection:[],
        multipleSuperList:[],
        goodsVisible:false
      };
    },
    filters:{
      
    },
    created() {
        this.searchMainList()
    },
    mounted() {
      
    },
    watch: {
    },
    methods: {
      formatMoney(num) {
            // 将数字转换为字符串并保留两位小数
            num = num.toFixed(2);

            // 将字符串按小数点分割成整数部分和小数部分
            var parts = num.toString().split(".");

            // 将整数部分每三位加一个逗号
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // 将整数部分和小数部分拼接起来
            return parts.join(".");
        },
        minHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '若需设定 60 以下，则在区间最大值填 60，最小值不用填；',
                h('br'),
               '若设定 [60,85) 则在最小值填60，最大值填85；',
               h('br'),
               '若设定 85 以上，则在最小值填 85，最大值不填。'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
        },
        maxHeader: function (h, { column, $index }) {
        return [
            column.label,
            h(
            'el-tooltip',
            {
                props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
                },
            },
            [
                h(
                'div',
                {
                    //当前div是为了实现换行，就这换行研究了好久。。。
                    slot: 'content',
                },
                [
                '若需设定 60 以下，则在区间最大值填 60，最小值不用填；',
                h('br'),
                '若设定 [60,85) 则在最小值填60，最大值填85；',
                h('br'),
                '若设定 85 以上，则在最小值填 85，最大值不填。'
                ],
                ),
                h('span', {
                //问号模块
                class: {
                    'el-icon-question': true,
                },
                }),
            ],
            ),
        ];
        },
        //新增明细
        addDetailList() {
            if (this.formData.levelType == 1) {
                //从字典选
                this.formData.detailList.push({
                    "relGuid": "",
                    "levelName": "",
                    "levelNote": "",
                    "minValue": "",
                    "maxValue": "",
                    "coefficient": "",
                    "orderNum": this.formData.detailList.length + 1
                })
            } else {
                this.goodsVisible = true;
                this.emptySearchSuper();
                
            }
        },
        //删除明细
        delDetailList(index) {
            this.formData.detailList.splice(index, 1)
        },
        dicGuidChange(guid) {
            let codeList = JSON.parse(localStorage.codeList);
            let obj = codeList.find(item => guid === item.guid);
            this.relGuidList = obj.dictList;
            this.formData.detailList = this.relGuidList.map((item, index) => {
                return {
                    "relGuid": item.guid,
                    "levelName": item.text,
                    "levelNote": "",
                    "minValue": "",
                    "maxValue": "",
                    "coefficient": "",
                    "orderNum": index + 1
                }
            })
        },
        relGuidChange(row){
            let obj = this.relGuidList.find(item => item.guid === row.relGuid)
            row.levelName = obj.text;
        },
        /**
         * 添加右侧分级规则
         */
        addData() {
            this.isAdd = true;
            this.editDialog = true;
            this.relGuidList = [];
            this.formData = {
                guid: '',
                ruleName: '', //规则名称
                ruleCode: '', // 规则编码
                orderNum: null, // 界面排序
                bizState: 'Y', // 启用状态
                levelType: '1',//分级方式
                dicGuid: '',//平台字典
                detailList: []
            }

        },
        // 修改右侧分级规则
        updateData(row) {
            this.isAdd = false
            this.editDialog = true
            this.api.get(`/${serverConfig.msConfigureService}/task-level-rule/detail?guid=${row.guid}`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.formData = res.data.data;
                    //字典
                    if(this.formData.levelType == 1){
                        let codeList = JSON.parse(localStorage.codeList);
                        let obj = codeList.find(item => this.formData.dicGuid === item.guid);
                        this.relGuidList = obj.dictList;
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            });

            console.log('gg', this.formData);
        },
        emptySearch() {
            this.ruleName = ''
            this.searchMainList()
        },

        //获取平台词典列表
        searchDetailList(row,isSearch) {
            this.dictTypeGuid = row.guid
            this.currentRow = row;
            this.loading = true;
            if (isSearch) {
              this.detailPage.pageIndex = 1;
              this.detailPage.pageSize = 50;
            }
            let req = this.detailPage;
            req.guid = this.dictTypeGuid
            this.api.postJson(`/${serverConfig.msConfigureService}/task-level-rule/detail-page-list`, req).then((res) => {
              this.loading = false
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.tableData = res.data.data.records || [];
                    this.detailPage.totalRows = res.data.data ? res.data.data.totalRows : 0
                    this.detailPage.totalPage = res.data.data ? res.data.data.totalPages : 0;
                    this.$nextTick(()=>{
                      let currentRow = this.tagList.filter(item => {
                          return item.guid === this.dictTypeGuid;
                      });
                      this.$refs['singleTable'].setCurrentRow(currentRow[0]);
                    })
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        detailSizeChange(pageSize){
          this.detailPage.pageSize = pageSize;
          this.searchDetailList(this.currentRow)//获取字典分类
        },
        detailCurrentChange(pageIndex){
          this.detailPage.pageIndex = pageIndex;
          this.searchDetailList(this.currentRow)//获取字典分类
        },
        searchMainList(show){
            let req = this.mainPage
            this.api.postJson(`/${serverConfig.msConfigureService}/task-level-rule/page-list`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.tagList = res.data.data.records || [];
                  this.mainPage.totalRows = res.data.data ? res.data.data.totalRows : 0
                  this.mainPage.totalPage = res.data.data ? res.data.data.totalPages : 0;
                  if (!this.tagList.length) return;
                  this.searchDetailList(this.currentRow||this.tagList[0]);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        mainCurrentChange(pageIndex){
          this.mainPage.pageIndex = pageIndex;
          this.searchMainList()//获取字典分类
        },
        // 提交分级规则
        submitDict() {
            let req = {
                ...this.formData,
            };
            let url = req.guid?'/task-level-rule/update':'/task-level-rule/save';
            let method = req.guid?'put':'postJson';
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    try {
                      if (!this.formData.detailList || !this.formData.detailList.length) {
                        throw new Error('请新增明细');
                      }
                      if (this.formData.detailList && this.formData.detailList.length) {
                        this.formData.detailList.forEach((item, idx) => {
                          if (item.coefficient==''||item.coefficient==null || !item.levelName) {
                            throw new Error('请完善信息后再新增');
                          }
                        });
                      }
                    } catch (e) {
                      this.$message.error(e.message);
                      return;
                    }
                    this.loading = true
                    this.api[method](`/${serverConfig.msConfigureService}${url}`, req).then((res) => {
                        this.loading = false;
                        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                            this.searchMainList();
                            this.editDialog = false;
                            this.isAdd = false
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        // 批量删除
        getDeleteData(type, guid) {
            console.log(type == 'detail')
            let that = this;
            let guids = [];
            let url = type == 'main'? '/task-level-rule/delete':'/task-level-rule/detail-delete';
            if (type == 'all' && that.multipleSelection.length == 0) {
                return that.$message.error("请勾选数据！");
            }
            if (type == 'all'&&that.multipleSelection.length) {
                guids = that.multipleSelection;
            }
            if (type == 'detail') {
                guids.push(guid);
                console.log(type, guid);
            }

            if (type == 'main') {
                guids.push(guid)
            }
         
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.api.postJson(`/${serverConfig.msConfigureService}${url}`, guids)
                    .then((res) => {
                        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                            that.$message.success('删除成功');
                            that.multipleSelection = [];
                            that.emptySearch()
                        } else {
                            that.$message.error(res.data.msg);
                        }
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        sureChooseGoods() {
            if (!this.multipleSuperList.length) {
                this.$message.error('请选择模板');
                return;
            }
            if (!this.formData.detailList.length) {
                this.formData.detailList = this.multipleSuperList.map((item, index) => {
                    return {
                        "relGuid": item.guid,
                        "levelName": item.taskContentName,
                        "levelNote":item.terminalTypeClassificationJson? this.codeTransformLable(JSON.parse(item.terminalTypeClassificationJson), this.getCodeListByKey('终端类型分类')):"",
                        "minValue": "",
                        "maxValue": "",
                        "coefficient": "",
                        "orderNum": index + 1
                    }
                })
            } else {
                let detailList = this.formData.detailList;
                let multipleSuperList = this.multipleSuperList;
                let templist = multipleSuperList.map((item, index) => {
                    return {
                        "relGuid": item.guid,
                        "levelName": item.taskContentName,
                        "levelNote":item.terminalTypeClassificationJson? this.codeTransformLable(JSON.parse(item.terminalTypeClassificationJson), this.getCodeListByKey('终端类型分类')):"",
                        "minValue": "",
                        "maxValue": "",
                        "coefficient": "",
                        "orderNum": ""
                    }
                })
                detailList = detailList.concat(templist);
                const map = new Map();
                const newArr = detailList.filter(v => !map.has(v.relGuid) && map.set(v.relGuid, v));
                this.formData.detailList = newArr;
                console.log(this.formData.detailList)
            }
            this.goodsVisible = false;
        },
        codeTransformLable(val, list) {
          console.log(val)
          console.log(list)
          if (!val || !val.length) return '-';
          let result = [];
          if (typeof val == 'string') {
            list.forEach(item => {
              if (item.value == val) {
                result.push(item.text);
              }
            })
          } else {
            list.forEach(item => {
              val.forEach(el => {
                if (el == item.value) {
                  result.push(item.text);
                }
              })
            })
          }
          console.log(result)
          return result.join('、');
        },
        // 右边列表的多选
        handleSelectionChange(val) {
            this.multipleSelection = [];
            val.forEach((item) => {
                this.multipleSelection.push(item.guid)
            })
            console.log('vv', this.multipleSelection);
        },
        goodsSizeChange(val) {
            this.superPage.pageSize = val;
            this.getSuperTemplateList();
        },
        goodsCurrentChange(val) {
            this.superPage.pageIndex = val;
            this.getSuperTemplateList();
        },
        //获取超级模版
        getSuperTemplateList(type) {
            if (type) {
                this.superPage = {
                    isSuper: 'Y',
                    pageIndex: 1,
                    pageSize: 50,
                    totalPage: 0,
                    totalRows: 0,
                    bizState: 'Y',
                    taskContentName: !this.superPage.taskContentName ? null : Array.isArray(this.superPage.taskContentName) ? this.superPage.taskContentName : [this.superPage.taskContentName],
                    menuName: this.superPage.menuName,
                    terminalTypeClassificationJson:this.superPage.terminalTypeClassificationJson,
                }
            }
            this.api
                .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, this.superPage)
                .then((res) => {
                    if (res.data.code != '00000') {
                        this.$message.error(res.data.msg);
                        return;
                    }
                    this.superTemplateList = res.data.data ? res.data.data.records : [];
                    this.superPage.totalRows = res.data.data ? res.data.data.totalRows : 0
                    this.superPage.totalPage = res.data.data ? res.data.data.totalPages : 0;
                    if (this.superTemplateList && this.superTemplateList.length&& this.formData.detailList.length) {                      
                        this.formData.detailList.forEach(m => {
                            this.superTemplateList.forEach(n => {
                                if (m.relGuid == n.guid) {
                                    console.log(n)
                                    this.$refs["dataTable"].toggleRowSelection(n, true);
                                }
                            })
                        })
                      
                    }
                });
        },
        emptySearchSuper() {
            this.superPage = {
                isSuper: 'Y',
                pageIndex: 1,
                pageSize: 50,
                totalPage: 0,
                totalRows: 0,
                bizState:'Y',
                taskContentName: null, //任务名称
                menuName: '', //菜单名称
            };
            this.getSuperTemplateList();
        },
        handleSuperSelectionChange(multipleSuperList) {
            this.multipleSuperList = multipleSuperList;  
        },
        btn(row, col, event) {
            row.flag = !row.flag;
            this.$refs.dataTable.toggleRowSelection(row, row.flag);
        },
    },
  };
  </script>
  <style lang="less" scoped>
  .level-box{
    border:1px solid #D9D9D9;
    height:300px !important;
    border-top:0 none;
    
  }
  .level-box-input{
    margin:10px 0;
  }
  .item-flex{
    display:flex;
    align-items: center;
    flex:1;

    
  }
  .import_new_wrap{
    padding: 0;
  }
  .read-title{
    text-align: left;
    margin: 6px 0px -10px 7px;
  }
  .state-class{
    height: 22px;
    box-sizing: border-box;
    background: #F2FFF5;
    border: 1px solid rgba(220,250,228,1);
    border-radius: 2px;
    font-size: 12px;
    color: #1BA854;
    letter-spacing: 0;
    line-height: 18px;
    padding:4px
  
    }
  .state-class-grey{
    height: 22px;
    box-sizing: border-box;
    background:  #F5F5F5;
    border: 1px solid rgba(217,217,217,1);
    border-radius: 2px;
    font-size: 12px;
    color: #404040;
    letter-spacing: 0;
    line-height: 18px;
    padding:4px
    
    }
  .all-classify{
    padding-left: 20px;
    text-align: center;
    width: 50%;
    padding: 12px 0;
  }
  .color-grey{
    background: #ecf5ff;
  }
  .left-content {
    width: 20%;
    height: 100%;
    padding: 20px;
    margin-right: 10px;
    background: #fff;
    border-radius: 4px;
  }
  .right-content {
    flex: 1;
    overflow: hidden;
  }
  .el-col-5 {
    width: 33%;
    margin-bottom: 15px;
  }
  .el-col-4 {
    width: 33%;
  }
  .payment-information {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    border: 1px solid #d2d2d3;
    border-radius: 4px;
    padding: 20px;
  }
  .pay-item {
    display: flex;
    width: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .pay-name {
    width: 100px;
    line-height: 32px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 10px;
  }
  .pay-left {
    width: 100%;
  }
  .pay-right {
    width: 10%;
    /* flex-shrink: 0; */
  }
  .i-edit-sty {
    font-size: 18px;
    margin-right: 4px;
  }
  .i-sty {
    font-size: 18px;
  }
  .btn {
    display: none;
  }
  .btn i {
    cursor: pointer;
  }
  .el-table__body tr:hover .btn {
    display: block;
  }
  /deep/ .table2 .el-icon-question{
    display:none;
  }
  /deep/.el-pagination {
    overflow-x: auto;
  }
  /deep/.el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
    // border: 0 none;
  }
  /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    // border: 0 none;
  }
  /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
    // border: 0 none;
  }
  /deep/ .el-tabs__nav-next {
    font-size: 20px;
  }
  /deep/.el-tabs__nav-prev {
    font-size: 20px;
  }
  /deep/.el-tabs__new-tab {
    margin-right: 16px;
  }
  .top {
    background: #fff;
    margin-bottom: 16px;
  }
   .el-table /deep/ .el-input__inner {
   height: 30px;
   line-height: 40px;
  }
  
  .el-range-editor.el-input__inner {
   padding: 0px;
  }
  
  /deep/ .el-checkbox__label {
   display: none;
  }
  
  .attach-sty {
   width: 170px;
   float: left;
   margin-top: 15px;
   text-align: center;
  }
  
  .checkbox-img-sty {
   border: 1px solid #dcdfe6;
   width: 16px;
   height: 16px;
   border-radius: 2px;
   cursor: pointer;
  }
  
  /deep/ .el-step__icon.is-text {
   border-radius: 50%;
   border-color: #4fa1a4;
   border-color: inherit;
  }
  
  /deep/ .el-step__icon-inner {
   color: #4fa1a4;
  }
  
  /deep/ .el-step__title.is-process {
   color: #4fa1a4;
  }
  
  // .content {
  //   background: #fff;
  //   font-size: 18px;
  // }
  
  .title {
   text-align: left;
   font-size: 16px;
   font-weight: 600;
   display: flex;
   align-items: center;
   margin-bottom: 10px;
  }
  
  .title span {
   width: 6px;
   height: 14px;
   background: #4fa1a4;
   display: inline-block;
   margin-right: 10px;
  }
  
  .base {
   background: #fff;
   padding: 10px 0;
  }
  
  .content h1 {
   margin: 4px 0px;
  }
  
  .base-content {
   display: flex;
   font-size: 15px;
   padding: 7px 0;
  }
  
  .base-content .base-info {
   display: flex;
   align-items: center;
   padding: 0 40px;
  }
  
  .base-content .base-info .base-title {
   word-break: keep-all;
  }
  
  .button-area {
   display: flex;
   justify-content: flex-start;
   padding: 0px 20px 0px 10px;
   margin:10px 0;
  }
  
  /deep/.el-checkbox__label {
   display: block;
  }
  
  .checkbox-show {
   display: flex;
   margin-bottom: 10px;
  }
  .field-show {
   display: flex;
   align-items: center;
   height: 40px;
   padding-left: 10px;
  }
  
  .product {
   display: flex;
   align-items: center;
  }
  
  .product-img {
   width: 60px;
   height: 40px;
   margin-right: 15px;
  }
  
  .product-text {
   width: 130px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
  }
  
   .el-col-5 {
     width: 33%;
   }
   
   .ipt-sty {
     width: 69% !important;
   }
   .add-btn{
     width: 80%;
     height:28px;
     line-height: 28px;
     margin: 8px 0px;
     padding: 0;
   }
   .flex{
     width: 80%;
     margin: auto;
     display: flex;
     justify-content: space-between;
   }
   .flex1{
     display: flex;
     flex-direction: column;
     justify-content: space-between;
   }
   
   .checkTag{
     background-color:rgb(242, 242, 242) ;
   }
   .btn {
   display: none;
  }
  .btn a {
   cursor: pointer;
  }
   .el-table__body tr:hover .btn {
   display: block;
  }
  
   /deep/.el-tree-node__label {
     width: 80%;
     white-space: normal;
     overflow: hidden;
     text-align: left;
   }
   
   .el-tree-node__content {
     height: auto;
   }
   
   .radio-ora {
     margin-right: 12px;
   }
   
   .staff-type {
     display: inline-block;
     width: 72px;
     height: 28px;
     line-height: 28px;
     color: #4FA1A4;
     background: rgba(234, 248, 248, 0.39);
     border-radius: 2px;
   }
   
   .staff-type-biz {
     display: inline-block;
     width: 52px;
     height: 28px;
     line-height: 28px;
     color: #4FA1A4;
     background: rgba(234, 248, 248, 0.39);
     border-radius: 2px;
   }
   
   .staff-wrap {
     color: #D8814B;
     background: rgba(255, 238, 224, 0.39);
   }
   
   .biz-state {
     display: inline-block;
     width: 48px;
     height: 21px;
     line-height: 21px;
     background: rgba(239, 239, 239, 0.38);
     border-radius: 11px;
     margin-left: 5px;
   }
   
   .select-node {
     margin: 0 0 17px 0;
     text-align: left;
     font-size: 18px;
     color: #323233;
   }
   
   .custom-tree-node {
     display: inline-flex;
     overflow: hidden;
   }
   
   .content-main-box {
     overflow-y: hidden;
     height:calc(100vh - 160px)
   }
   
   .el-col-6{
    display: flex;
    /* margin-bottom: 10px; */
  }
   .el-col-8{
    display: flex;
    /* margin-bottom: 10px; */
  }
  .search-area-div {
    width: 64px;
    /* text-align: right; */
  }
  .ipt-sty{
    flex: 1; 
  }
   /* .el-pagination {
     width: calc(100% - 260px - 231px);
   } */
   .icon-dialog {
    display: flex;
    overflow: hidden;
  }
  
  .icon-dialog .icon-left {
    width: 180px;
    text-align: left;
    border-right: 1px solid #cccc;
  }
  
  .icon-left .item {
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    padding: 0 20px;
  }
  
  .icon-dialog .icon-right {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    height: auto;
    padding-left: 10px;
  }
  
  .icon-right .pic {
    width: 100px;
    height: 130px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  .icon-right .pic .img {
    width: 100px;
    height: 100px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.06);
  }
  
  .icon-right .pic .img:hover {
    border: 1px solid #4fa1a4;
    border-radius: 4px;
  }
  
  .img-wrap {
    position: relative;
  }
  
  .img-wrap .border-img {
    position: absolute;
    width: 100px;
    height: 100px;
    left: 0;
    top: 0;
  }
  
  .img-wrap .name {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .file-img {
    width: 100%;
    height: 100%;
  }
  
  .icon-add {
    float: left;
    margin-left: 10px;
    width: 150px;
    height: 150px;
    border: 1px dotted #ccc;
    text-align: center;
    line-height: 150px;
  }
  
  .img-close {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 20px;
  }
  
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  /deep/ .el-table-column--selection .cell{
    padding-right:10px
  }
  .left-tree-box{
    width:280px;
  }
  .right-content-box{
    width: calc(100% - 290px);
  }
  </style>
  <style>
    .first-table .el-table .el-table__cell {
    padding:6px;
    cursor:pointer;
  }
  .icon-dialog-wrap .el-dialog__body {
    padding: 0;
    padding-top: 10px;
  }
  #template-config .el-dialog {
      /* height: 80vh; */
      overflow: auto;
  }
  #template-config .el-form-item__content{
    margin-left:15px !important;
    display: flex;
  }
  #template-config .el-form-item{
    align-items:flex-start;
  }
  #template-config .calc-type .el-form-item__label{
    line-height:15px;
  }
  .el-table .cell{
    white-space: nowrap;
  }
    .el-input__inner{
      padding: 0 8px;
    }
    .detail-class .el-table__row{
      height: 12px;
      line-height: 12px;
    }
    .el-collapse-item__header {
      padding-left: 15px;
    }
    
    .el-upload--picture-card {
      float: left;
      margin-right: 10px;
    }
    
    .circle-closesty {
      position: relative;
      top: -35px;
      margin-left: 112px;
      font-size: 20px;
      cursor: pointer;
    }
    
    .v-modal {
      z-index: 100 !important;
    }
    
    .select-box {
      overflow: hidden;
      margin: 0 0px 10px 30px;
    }
    
    .box-left {
      width: 40%;
      height: 350px;
      padding: 0 20px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
      overflow-y: auto;
    }
    
    .box-right {
      width: 57%;
      height: 350px;
      padding: 0 10px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
    }
    
    .field-radio {
      display: flex;
      align-items: center;
    }
    
    .field-radio .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item {
      margin-bottom: 18px;
    }
    
    .other-config {
      display: flex;
      font-size: 14px;
      padding-left: 50px;
      /* padding-top: 30px; */
    }
    
    .other-content {
      flex: 1;
    }
    
    .other-content-list {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    
    .other-title {
      padding-right: 10px;
    }
    
    /* 报货配置 */
    .bh-config-box {
      display: flex;
      height: 40px;
      align-items: center;
      font-size: 14px;
      padding-left: 50px;
      padding-top: 10px;
    }
    
    .bh-config-title {
      margin-right: 10px;
    }
    
    /* 库存信息采集 */
    .kc-label {
      font-size: 12px;
      color: #86909c;
    }
    
    .kc-label span {
      color: #4fa1a4;
      cursor: pointer;
    }
    
    .kc-box {
      padding: 16px;
      box-sizing: border-box;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
      color: #323232;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #323232;
    }
    .el-tabs__item.is-active{
      color: #4fa1a4;
    }
    .kc-box .el-tabs__item {
      border-right: 1px solid #dcdfe6 !important;
    }
    
    .kc-tab-box {
      height: 340px;
      padding: 0 0 40px;
      font-size: 14px;
      overflow-y: auto;
      box-sizing: border-box;
   } 
    
    .kc-tab-list{
      padding: 0 0 40px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdcdc;
    }
    
    .kc-tab-list:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    
    .kc-tab-label {
      display: flex;
      margin-top: 30px;
    }
    
    .label-left-name img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    
    .tab-label-left {
      width: 350px;
      display: flex;
      margin-right: 20px;
    }
    
    .label-left-name {
      width: 100px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      flex-shrink: 0;
    }
    
    .tab-label-right {
      display: flex;
      align-items: center;
      color: #c8c8c8;
    }
    
    .tab-label-add {
      color: #4fa1a4;
      cursor: pointer;
      margin-right: 10px;
    }
    
    .tab-label-del {
      color: #d0021b;
      cursor: pointer;
      margin: 0 10px;
    }
    
    .kc-tab-rules {
      display: flex;
      margin-top: 16px;
    }
    
    .kc-rules-center {
      display: flex;
      align-items: center;
    }
    
    .rules-center-input span {
      margin: 0 8px;
    }
    
    .kc-no-label {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .kc-no-label img {
      width: 213px;
      margin-right: 35px;
    }
    
    .no-label-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    
    .no-label-text h3 {
      font-size: 18px;
      color: #7f828f;
      text-align: left;
      font-weight: 500;
      margin: 0;
    }
    
    .no-label-text p {
      font-size: 14px;
      color: #7f828f;
      line-height: 20px;
      margin: 6px 0 13px;
      text-align: left;
    }
    
    .no-label-btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      text-align: center;
      color: #4fa1a4;
      cursor: pointer;
      border: 1px solid #4fa1a4;
    }
    
    .dy-table {
      width: 800px;
      margin-left: 10px;
    }
    
    .dy-table .dy-table-title {
      display: flex;
      height: 60px;
      line-height: 60px;
      background: #f2f2f2;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table .dy-table-title div {
      width: 200px;
    }
    
    .dy-table .dy-table-item {
      display: flex;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table-item-label {
      width: 200px;
      flex-shrink: 0;
      text-align: center;
    }
    
    .dy-table .dy-radio-box {
      width: 200px !important;
      text-align: center;
    }
    
    .dy-config-wrap {
      display: flex;
      font-size: 14px;
      margin: 30px 0;
      padding-left: 50px;
    }
    
    .dy-config-title {
      flex-shrink: 0;
      margin-top: 20px;
    }
    
    .product-select-all {
      margin-bottom: 20px;
    }
    .title-content {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      width: 100%;
    }
    .title-item {
      vertical-align: middle;
      text-align: center;
      padding-right: 10px;
    }
    .left-text {
      text-align: left;
    }
    .w200 {
      width: 30%;
    }
    .w160 {
      width: 160px;
    }
    .w240 {
      width: 200px;
    }
    .w100 {
      width: 100px;
    }
    .configure-fields {
      width: 760px !important;
    }
    .configure-fields .el-dialog__body {
      overflow-y: auto;
      max-height: 600px;
    }
    .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /* 选项内容样式 */
    .select-content-box {
      width: 92%;
      margin: 0 0px 10px 30px;
    }
    .select-content {
      width: 100%;
      /* padding:0 10px; */
      background: #fafafa;
      border: 1px solid #e5e5e5;
    }
    .el-form-item__label {
      color: #666;
    }
    .select-content .el-form-item__label {
      width: 90px !important;
    }
    .select-content .el-form-item__content {
      margin-left: 90px !important;
    }
    .config-item .el-form-item__content {
      margin-left: 0px !important;
    }
    /*  */
    .max-value {
      position: relative;
      height: 40px;
    }
    .max-value .el-input-number--mini {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 104px;
    }
  </style>
  
  